import React, { useEffect, useState } from 'react';
import { TableHeader } from 'src/components/molecules/MOLTable/MOLTable';
// import ATMMenu from 'src/components/atoms/ATMMenu/ATMMenu';
// import { IconDotsVertical, IconDownload, IconEye } from '@tabler/icons-react';
import { Invoices } from '../../models/Invoices.model';
import InvoicesListing from './InvoicesListing';
import { useFilterPagination } from 'src/hooks/useFilterPagination';
import { useFetchData } from 'src/hooks/useFetchData';
import {
  useGetInvoicesQuery,
  useUpdateInvoiceMutation,
} from '../../service/InvoicesServices';
import { format, subMonths } from 'date-fns';
import { CURRENCY } from 'src/utils/constants';
import { FilterType } from 'src/components/molecules/MOLFilterBar/MOLFilterBar';
import { useGetOutletsQuery } from 'src/modules/Outlet/service/OutletServices';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { RootState, AppDispatch } from 'src/store';
import ATMMenu from 'src/components/atoms/ATMMenu/ATMMenu';
import {
  IconDotsVertical,
  IconPrinter,
  IconCreditCardRefund,
  IconCopyX,
} from '@tabler/icons-react';
import { useGetCustomersQuery } from 'src/modules/Customer/service/CustomerServices';
import {
  setIsOpenAddDialog,
  setIsOpenEditDialog,
} from '../../slice/InvoicesSlice';
import EditCategoryFormWrapper from '../Edit/EditInvoiceVoidFormWrapper';
import toast from 'react-hot-toast';
import { Tooltip } from 'react-tooltip'
import { showToast } from 'src/utils/showToaster';
import { formatZonedDate } from 'src/utils/formatZonedDate';
import ShowConfirmation from 'src/utils/ShowConfirmation';
import { debounce } from '@syncfusion/ej2-base';
type Props = {};

const InvoicesListingWrapper = (props: Props) => {
  const dispatch = useDispatch<AppDispatch>();

  const { searchQuery, limit, page, dateFilter, appliedFilters } =
    useFilterPagination(['outletId', 'customerId']);

  const navigate = useNavigate();
  const location = useLocation();
  const { outlets } = useSelector((state: RootState) => state.auth);
  const { isOpenEditDialog } = useSelector(
    (state: RootState) => state?.invoices,
  );
  const [customerSearch, setCustomerSearch] = useState('');

  let filterBy: any[] = [];

  const isEmail = customerSearch.includes('@'); // ✅ Check email first
  const isNumber = /^\d+$/.test(customerSearch);

  if (isEmail) {
    filterBy = [{ fieldName: 'email', value: customerSearch }];
  } else if (isNumber) {
    filterBy = [{ fieldName: 'phone', value: customerSearch }];
  } else {
    filterBy = [{ fieldName: 'customerName', value: customerSearch }];
  }

  const { data: customerData, isLoading: customerLoading } = useFetchData(
    useGetCustomersQuery,
    {
      params: {
        limit,
        page,
        isPaginationRequired: true,
        filterBy: JSON.stringify(filterBy),
      },
    }
  );
  const [searchParams, setSearchParams] = useSearchParams();
  const [invoiceId, setInvoiceId] = useState('');
  const [updateInvoice] = useUpdateInvoiceMutation();
  const [invoiceStatus, setInvoiceStatus] = useState('');
  const { data, isLoading, totalData, totalPages } = useFetchData(
    useGetInvoicesQuery,
    {
      body: {
        limit,
        page,
        searchValue: searchQuery,
        searchIn: JSON.stringify(['invoiceNumber']),
        dateFilter: JSON.stringify({
          dateFilterKey: 'createdAt',
          // startDate: dateFilter?.start_date || format(new Date(), 'yyyy-MM-dd'),
          // endDate: dateFilter?.end_date || format(new Date(), 'yyyy-MM-dd'),

          startDate: dateFilter?.start_date || format(subMonths(new Date(), 1), 'yyyy-MM-dd'),
          endDate: dateFilter?.end_date || format(new Date(), 'yyyy-MM-dd')
        }),
        filterBy: JSON.stringify(appliedFilters),
      },
    },
  );


  const handleCustomerSearch = debounce((value: string) => {
    setCustomerSearch(value);
  }, 400);

  const handleUpdate = async (item: any) => {
    try {
      await updateInvoice({
        invoiceId: item?._id,
        body: { status: item?.status === "" ? 'refund' : "", voidNote: "" },
      }).unwrap();
      // alert('Invoice updated successfully!');
      if (item?.status == "refund") {
        showToast('success', 'Unrefund Process successfully!')

      }
      else {
        showToast('success', 'Refund Process successfully!')
      }

    } catch (error) {
      console.error('Error updating invoice:', error);
      // alert('Failed to update invoice.');

      showToast('error', 'Failed to update invoice.')
    }
  };

  const handleCancelVoidWithConfirmation = (invoiceId: any) => {
    updateInvoice({ body: { status: "", voidNote: "" }, invoiceId }).then((res: any) => {
      if (res?.error) {
        showToast('error', res?.error?.data?.message)
      } else {
        if (res?.data?.status) {
          showToast('success', res?.data?.message)
        } else {
          showToast('error', res?.data?.message)
        }
      }
    });
  }
const tableHeaders: TableHeader<Invoices>[] = [
  {
    fieldName: 'createdAt',
    headerName: 'Date',
    resizable: true,
    width: 120,
    renderCell: (item) =>
      item?.createdAt ? formatZonedDate(item?.createdAt) : '-',
  },
  {
    fieldName: 'invoiceNumber',
    headerName: 'Invoice',
    resizable: true,
    width: 140,
  },
  {
    fieldName: 'customerName',
    headerName: 'Customer',
    resizable: true,
    width: 220,
    renderCell: (item) =>
      item
        ? item.customerName.charAt(0).toUpperCase() + item.customerName.slice(1)
        : '',
  },
  {
    fieldName: 'giftCardCode',
    headerName: 'Gift Code',
    resizable: true,
    width: 140,
  },
  {
    fieldName: 'giftCardDiscount',
    headerName: 'Gift Discount',
    resizable: true,
    width: 130,
    align: 'end',
    renderCell: (item) => (
      <div>
        {CURRENCY}{' '}
        {item?.giftCardDiscount ? Number(item?.giftCardDiscount).toFixed(2) : '0'}
      </div>
    ),
  },
  {
    fieldName: 'totalAmount',
    headerName: 'Total',
    resizable: true,
    width: 110,
    align: 'end',
    renderCell: (item) => (
      <div>
        {CURRENCY}{' '}
        {item?.totalAmount ? Number(item?.totalAmount).toFixed(2) : '0'}
      </div>
    ),
  },
  {
    fieldName: 'status',
    headerName: 'Status',
    align: 'center',
    resizable: true,
    width: 110,
    renderCell: (item) => (
      <div>
        {item.status && item.status.trim() !== '' ? (
          <span className="text-red-700 bg-red-100 py-[3px] font-medium px-2 rounded-lg border-slate-300">
            {item.status}
          </span>
        ) : item?.balanceDue > 0 ? (
          <span className="text-yellow-700 bg-yellow-100 py-[3px] font-medium px-2 rounded-lg border-slate-300">
            Unpaid
          </span>
        ) : (
          <span className="text-green-700 bg-green-100 py-[3px] font-medium px-2 rounded-lg border-slate-300">
            Paid
          </span>
        )}
      </div>
    ),
  },
  {
    fieldName: 'notes',
    headerName: 'Note',
    resizable: true,
    width: 180,
    renderCell: (item) => {
      const note = item.notes || '';
      const tooltipId = `note-tooltip-${item._id}`;

      return (
        <>
          <span
            data-tooltip-id={tooltipId}
            data-tooltip-content={note}
            className="cursor-pointer hover:underline"
          >
            {note.length > 20 ? `${note.substring(0, 20)}...` : note}
          </span>
          <Tooltip
            id={tooltipId}
            delayShow={300}
            className="z-50 !bg-gray-800 !text-white !text-sm !max-w-[200px] !max-h-[150px] 
            !overflow-y-auto !whitespace-pre-wrap !px-3 !py-2"
            place="top"
            noArrow={true}
          />
        </>
      );
    },
  },
  {
    fieldName: 'action',
    headerName: 'Action',
    align: 'center',
    resizable: false,         // 🚫 action column fixed — chhoti si rehni chahiye
    width: 80,
    renderCell: (item: Invoices) => (
      <div>
        <ATMMenu
          children={<IconDotsVertical />}
          items={[
            {
              label: 'View',
              icon: IconPrinter,
              onClick: () => {
                navigate(`/invoice/receipt/${item?._id}`, {
                  state: { from: location },
                });
              },
            },
            {
              label: item?.status === 'refund' ? 'Cancel Refund' : 'Refund',
              icon: IconCreditCardRefund,
              onClick: () => {
                if (item?.status === 'refund') {
                  ShowConfirmation({
                    type: 'INFO',
                    title: 'Are you sure?',
                    message: 'Do you want to refund on this invoice?',
                    onConfirm: (closeDialog) => {
                      handleUpdate(item);
                      closeDialog();
                    },
                    confirmationText: `${
                      item?.status === 'refund' ? 'Cancel Refund' : 'Refund'
                    }`,
                  });
                } else {
                  dispatch(setIsOpenEditDialog(true));
                  setInvoiceId(item._id);
                  setInvoiceStatus('refund');
                }
              },
            },
            {
              label: item?.status === 'void' ? 'Cancel Void' : 'Void',
              icon: IconCopyX,
              onClick: () => {
                if (item?.status === 'void') {
                  ShowConfirmation({
                    type: 'INFO',
                    title: 'Are you sure?',
                    message: 'Do you want to undo void on this invoice?',
                    onConfirm: (closeDialog) => {
                      handleCancelVoidWithConfirmation(item._id);
                      closeDialog();
                    },
                    confirmationText: `${
                      item?.status === 'void' ? 'Cancel void' : 'void'
                    }`,
                  });
                } else {
                  dispatch(setIsOpenEditDialog(true));
                  setInvoiceId(item._id);
                  setInvoiceStatus('void');
                }
              },
            },
          ]}
        />
      </div>
    ),
  },
];

  const filters: FilterType[] = [
    {
      filterType: 'multi-select',
      label: 'Outlet',
      fieldName: 'outletId',
      options:
        outlets?.map((el: any) => {
          return {
            label: el?.name,
            value: el?._id,
          };
        }) || [],
      renderOption: (option) => option.label,
      isOptionEqualToSearchValue: (option, value) => {
        return option?.label.includes(value);
      },
    },
    {
      filterType: 'multi-select',
      label: 'Customer',
      fieldName: 'customerId',
      options:
        customerData?.map((el: any) => {
          return {
            label: el?.customerName,
            value: el?._id,
          };
        }) || [],
      renderOption: (option) => option.label,
      isOptionEqualToSearchValue: (option, value) => {
        return option?.label.includes(value);
      },
      onInputChange: (value: string) => {
        handleCustomerSearch(value);
      },
    },
    {
      filterType: 'date',
      fieldName: 'createdAt',
      dateFilterKeyOptions: [
        {
          label: 'startDate',
          value: dateFilter?.start_date || '',
        },
        {
          label: 'endDate',
          value: dateFilter?.end_date || '',
        },
      ],
    },
  ];

  const today = new Date();
  const oneMonthAgo = subMonths(today, 1);

  useEffect(() => {
    if (!dateFilter?.start_date && !dateFilter?.end_date) {
      const newSearchParams = new URLSearchParams(searchParams); // Clone existing searchParams
      newSearchParams.set('startDate', format(oneMonthAgo, 'yyyy-MM-dd') || '');
      newSearchParams.set('endDate', format(new Date(), 'yyyy-MM-dd') || '');
      const existingOutlets = newSearchParams.getAll('outletId');
      const newOutletIds = outlets?.map((item) => item?._id) || [];
      if (JSON.stringify(existingOutlets) !== JSON.stringify(newOutletIds)) {
        newSearchParams.delete('outletId'); // Remove existing outletId params
        newOutletIds.forEach((id) => {
          newSearchParams.append('outletId', id); // Append new outlet IDs
        });
        setSearchParams(newSearchParams);
      }
    }
  }, [dateFilter, outlets]);

  return (
    <>
      <InvoicesListing
        tableHeaders={tableHeaders}
        isLoading={isLoading}
        filter={filters}
        rowData={data as Invoices[]}
        filterPaginationData={{
          totalCount: totalData,
          totalPages: totalPages,
        }}
      />
      {isOpenEditDialog && (
        <EditCategoryFormWrapper
          onClose={() => dispatch(setIsOpenEditDialog(false))}
          invoiceId={invoiceId}
          invoiceStatus={invoiceStatus}
        />
      )}
    </>
  );
};

export default InvoicesListingWrapper;
